/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import Container from '../../../common/Container/Container'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import Accordion from '../../../common/Accordion/Accordion'
import Loading from '../../../common/Loading/Loading'

import Step00View from './components/Step00View'
import Step01 from '../../../../containers/pages/Quote/Step01'
import Step02 from '../../../../containers/pages/Quote/Step02'
import Step03 from '../../../../containers/pages/Quote/Step03'
import Step03m from './containers/Step03m'
import Step03d from '../../../../containers/pages/Quote/Step03d'
import Step03c from '../../../../containers/pages/Quote/Step03c'
import Step04 from '../../../../containers/pages/Quote/Step04'
// import Step04c from '../../../../containers/pages/Quote/Step04c'
import Step04c from './containers/Step04c'
import Step04m from './containers/Step04m'
import Step04d from './containers/Step04d'
import Step05 from '../../../../containers/pages/Quote/Step05'
import Step05c from './containers/Step05c'
import Step05m from './containers/Step05m'
import Step05d from './containers/Step05d'

/**
 *     Import
 *     - Styles
 */
// import '../styles/Quote.css'

export default class EditRenewals extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            accordions: {
                accor01: false,
                accor02: false,
                accor03: false,
                accor04: false,
                accor05: false,
                accor06: false,
            },
            checkStep03update: false,
            checkStep04update: true,
            checkStep02OnlyUpdate: '',
            renewalQuoteId: false,
        }
    }

    componentDidMount() {
        const policyId = this.props.match.params.id
        this.props.getFullQuoteRenewal(policyId).then((res) => {
            let renewalQuoteId = get(res, 'value.renewal.id', false)
            if (renewalQuoteId) {
                this.setState({ renewalQuoteId })
            }
        })
    }

    /**
     * Handle the Accordion toggle
     */
    handleAccordion = (name: string) => {
        this.setState({
            ...this.state,
            accordions: { ...this.state.accordions, [name]: !this.state.accordions[name] },
        })
    }

    handleCancel = () => { return true }

    checkStep03Update = () => {
        let { riskLocations: { response } } = this.props.quote
        if (response.length === 1) {
            this.setState({ checkStep04update: true })
        } else {
            this.setState({ checkStep04update: false })
        }
    }

    render() {

        let { response, loading, done } = this.props.quote.fullRenewals
        let { riskLocations } = this.props.quote
        const { isCollectors, isMuseums, isDealersStock } = this.props
        const { renewalQuoteId } = this.state
        return (
            <div className="quote quote--edit">

                <HeaderContainer
                    className="quote__header"
                    fullwidth={false}
                    pretitle={(isCollectors) ? 'Collections Policy' : isMuseums ? 'Museums Policy' : isDealersStock ?
                        'Dealers Stock Policy' : 'Commercial Art Insurance'}
                    titles={['Renew policy']}
                />

                <Container className="quote__edit container__wider" fullwidth={false}>
                    {(renewalQuoteId) ?
                        <div className="quote__edit__infoblock">

                            <Accordion
                                title="Client Details"
                                onChange={() => this.handleAccordion('accor01')}
                            >
                                {(!loading && done) ? (
                                    <Step00View values={response} />
                                ) : <Loading />}
                            </Accordion>

                            <Accordion
                                title="Policy Details"
                                onChange={() => this.handleAccordion('accor02')}
                            >
                                {(!loading && done) ? (
                                    <Step01
                                        data={response}
                                        editQuote={true}
                                        match={this.props.match}
                                        editRenewal={true}
                                        renewalQuoteId={get(response, 'renewal.id')}
                                    />
                                ) : <Loading />}
                            </Accordion>

                            <Accordion
                                title="Risk Address"
                                onChange={() => this.handleAccordion('accor03')}
                            >
                                {(get(response, 'renewal.id')) ? <Step02
                                    renewalQuoteId={renewalQuoteId}
                                    editQuote={true}
                                    match={this.props.match}
                                    editRenewal={true}
                                    isCollectors={(isCollectors) ? true : false}
                                    isMuseums={isMuseums}
                                    isDealersStock={isDealersStock}
                                    step02Update={
                                        () => this.setState({
                                            checkStep04update: false,
                                            checkStep02OnlyUpdate: true,
                                        })
                                    }
                                /> : null}

                            </Accordion>

                            <Accordion
                                title={(isCollectors) ? 'Collection Assets' : isMuseums ? 'Museums Assets' :
                                    isDealersStock ? 'Dealers Stock Assets' : 'Add Stock & Business Assets'}
                                onChange={() => this.handleAccordion('accor04')}
                            >
                                {(!loading && done) ? (
                                    (isCollectors) ?
                                        <Step03c
                                            data={response.renewal.stockBusinessAssets}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            step03Update={
                                                () => {
                                                    this.setState({
                                                        checkStep03update: true,
                                                        checkStep02OnlyUpdate: false,
                                                    })
                                                    this.checkStep03Update()
                                                }}
                                        /> : isMuseums ? <Step03m
                                            data={response.renewal.stockBusinessAssets}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            step03Update={
                                                () => {
                                                    this.setState({
                                                        checkStep03update: true,
                                                        checkStep02OnlyUpdate: false,
                                                    })
                                                    this.checkStep03Update()
                                                }}
                                        /> : isDealersStock ? <Step03d
                                            data={response.renewal.stockBusinessAssets}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            step03Update={
                                                () => {
                                                    this.setState({
                                                        checkStep03update: true,
                                                        checkStep02OnlyUpdate: false,
                                                    })
                                                    this.checkStep03Update()
                                                }}
                                        /> : <Step03
                                            data={response.renewal.stockBusinessAssets}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            step03Update={
                                                () => this.setState({
                                                    checkStep02OnlyUpdate: false,
                                                })}
                                        />
                                ) : <Loading />}
                            </Accordion>

                            <Accordion
                                title={(isCollectors) ? 'Collections Locations' : isMuseums ? 'Museums Locations' :
                                    isDealersStock ? 'Dealers Stock Locations' : 'Additional Cover'}
                                onChange={() => this.handleAccordion('accor05')}
                            >
                                {(!loading && done) ? (
                                    (isCollectors) ?
                                        <Step04c
                                            data={response.renewal.additionalCover}
                                            riskLocations={riskLocations}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            checkStep03update={this.state.checkStep03update}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={
                                                () => this.setState({
                                                    checkStep04update: true,
                                                    checkStep02OnlyUpdate: false,
                                                })}
                                        /> : isMuseums ? <Step04m
                                            data={response.renewal.additionalCover}
                                            riskLocations={riskLocations}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            checkStep03update={this.state.checkStep03update}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={
                                                () => this.setState({
                                                    checkStep04update: true,
                                                    checkStep02OnlyUpdate: false,
                                                })}
                                        /> : isDealersStock ? <Step04d
                                            data={response.renewal.additionalCover}
                                            riskLocations={riskLocations}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            checkStep03update={this.state.checkStep03update}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={
                                                () => this.setState({
                                                    checkStep04update: true,
                                                    checkStep02OnlyUpdate: false,
                                                })}
                                        /> : <Step04
                                            data={response.renewal.additionalCover}
                                            editQuote={true}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={
                                                () => this.setState({
                                                    checkStep04update: true,
                                                    checkStep02OnlyUpdate: false,
                                                })}
                                        />
                                ) : <Loading />}
                            </Accordion>

                            <Accordion
                                title="Cover Options and Quote Preview"
                                onChange={() => this.handleAccordion('accor06')}
                            >
                                {(!loading && done) ? (
                                    (isCollectors) ?
                                        <Step05c
                                            data={response.quote}
                                            editQuote={true}
                                            history={this.props.history}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={this.state.checkStep04update}
                                            checkStep02OnlyUpdate={this.state.checkStep02OnlyUpdate}
                                        /> : isMuseums ? <Step05m
                                            data={response.quote}
                                            editQuote={true}
                                            history={this.props.history}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={this.state.checkStep04update}
                                            checkStep02OnlyUpdate={this.state.checkStep02OnlyUpdate}
                                        /> : isDealersStock ? <Step05d
                                            data={response.quote}
                                            editQuote={true}
                                            history={this.props.history}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep04update={this.state.checkStep04update}
                                            checkStep02OnlyUpdate={this.state.checkStep02OnlyUpdate}
                                        /> : <Step05
                                            data={response.quote}
                                            editQuote={true}
                                            history={this.props.history}
                                            match={this.props.match}
                                            editRenewal={true}
                                            renewalQuoteId={get(response, 'renewal.id')}
                                            checkStep02OnlyUpdate={this.state.checkStep02OnlyUpdate}
                                        />
                                ) : <Loading />}
                            </Accordion>

                        </div> : null}

                </Container>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/EditRenewals/EditRenewals.tsx